<ng-select
  [items]="options"
  bindLabel="title"
  bindValue="value"
  [closeOnSelect]="true"
  [searchable]="true"
  [virtualScroll]="true"
  [clearable]="true"
  [minTermLength]="0"
  [bufferAmount]="20"
  [trackByFn]="trackByFn"
  dropdownPosition="auto"
  appendTo="body"
  [placeholder]="getPlaceholder()"
  [(ngModel)]="field.value"
  (ngModelChange)="modelChangeEmit.emit($event)"
  (search)="onSearch($event)"
>
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div [innerHTML]="highlightMatch(item?.title ?? '', search)"></div>
  </ng-template>

  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
    <div class="custom-header">
      <span *ngIf="searchTerm">No state found for "{{ searchTerm }}"</span>
      <span *ngIf="!searchTerm && options.length === 0">No states available</span>
      <span *ngIf="!searchTerm && options.length > 0">Type to search...</span>
    </div>
  </ng-template>

  <ng-template ng-loading-tmp>
    <div class="custom-header"><span>Loading states...</span></div>
  </ng-template>
</ng-select>
